import React, { FC, useCallback } from 'react';
import { CognitoUser } from 'amazon-cognito-identity-js';
import styles from '../../index.module.scss';
import SetupMfaQrCode from 'src/common/Setup2faQrCode';
import { Button } from 'src/common';
import { useTranslation } from 'react-i18next';
import { Auth } from 'aws-amplify';
import { useUpdateMFAMode } from 'src/models/company/Security/hooks';
import { MfaMode } from 'src/models/users/types';

interface IProps {
  code: string;
  email: string;
  onFinish: () => void;
  onBackClick: () => void;
  cognitoUser?: CognitoUser;
}

export const QrCode: FC<IProps> = props => {
  const { code, email, onFinish, onBackClick, cognitoUser } = props;
  const { t } = useTranslation();
  const [updateMfaMode] = useUpdateMFAMode();

  const verifyTotpToken = useCallback(
    (code: string) => {
      return Auth.verifyTotpToken(cognitoUser, code).then(() => {
        /* empty fn */
      });
    },
    [cognitoUser]
  );

  const setPreferredMFA = useCallback(async (): Promise<void> => {
    return await Auth.setPreferredMFA(cognitoUser, MfaMode.TOTP).then(() => {
      /* empty fn */
    });
  }, [cognitoUser]);

  const onMFACodeConfirmed = useCallback(async () => {
    await updateMfaMode({
      variables: {
        email,
        mfaMode: MfaMode.TOTP
      }
    });
    onFinish();
  }, [email, onFinish, updateMfaMode]);
  return (
    <>
      <h2 className={styles.subTitle}>{`${t('Security.mfaAuth')} - ${t('Security.setup')}`}</h2>
      <div className={styles.content}>
        {cognitoUser && (
          <SetupMfaQrCode
            username={cognitoUser.getUsername()}
            verifyTotpToken={verifyTotpToken}
            setPreferredMFA={setPreferredMFA}
            submitTitle={t('Common.next')}
            code={code}
            onAfterSubmit={onMFACodeConfirmed}
            extra={
              <Button type={'text'} onClick={onBackClick}>
                {t('Common.cancel')}
              </Button>
            }
          />
        )}
      </div>
    </>
  );
};

export default QrCode;
